// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/Customer.yaml
// Generated: 2025-11-13T17:17:06.999Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateCustomer, UpdateCustomer, Customer } from '@/types/sales/Customer';

/**
 * Customer Service
 * CRUD operations for Customer via the ABP API.
 */
export const customerService = new EntityService<Customer, CreateCustomer, UpdateCustomer>(
  '/api/sales/customer',
  'Customer',
);
